// extracted by mini-css-extract-plugin
module.exports = {"menu":"index_menu__1frxv","action":"index_action__2iSde","icon":"index_icon__3hgvT","name":"index_name__VUoUj"};